import { motion } from "framer-motion";
import React, { useState, useEffect } from "react";
import ReactTooltip from "react-tooltip";
import { SkillSet, Experience } from "../../constants";
import AppWrap from "../../wrapper/AppWrap";
import MotionWrap from "../../wrapper/MotionWrap";
import "./Skills.scss";

const Skills = () => {
  const [skills, setSkills] = useState([]);
  const [experience, setExperience] = useState([]);

  useEffect(() => {
    setSkills(SkillSet);
    setExperience(Experience);
  }, []);

  return (
    <div className="app__skills">
      <h2 className="head-text">Skills & Experience</h2>

      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skills?.map((skill) => {
            return (
              <motion.div
                whileInView={{ opacity: [0, 1] }}
                transition={{ duration: 0.5 }}
                className="app__skills-item app__flex"
                key={skill.id}
              >
                <div
                  className="app__flex"
                  style={{ backgroundColor: skill.bgColor }}
                >
                  <img src={skill.imageUrl} alt={skill.name} />
                </div>
                <p className="p-text">{skill.name}</p>
              </motion.div>
            );
          })}
        </motion.div>
        <motion.div className="app__skills-exp">
          {experience?.map((yearWork) => {
            return (
              <motion.div className="app__skills-exp-item" key={yearWork.year}>
                <div className="app__skills-exp-year">
                  <p className="bold-text">{yearWork.year}</p>
                </div>
                <motion.div className="app__skills-exp-works">
                  {yearWork.works.map((work) => {
                    return (
                      <div key={work.name + work.workId}>
                        <motion.div
                          whileInView={{ opacity: [0, 1] }}
                          transition={{ duration: 0.5 }}
                          className="app__skills-exp-work"
                          data-tip
                          data-for={work.name}
                        >
                          <h4 className="bold-text">{work.name}</h4>
                          <p className="p-text">{work.company}</p>
                        </motion.div>
                        <ReactTooltip
                          id={work.name}
                          effect="solid"
                          arrowColor="#ffffff"
                          className="skills-tooltip"
                        >
                          {work.description}
                        </ReactTooltip>
                      </div>
                    );
                  })}
                </motion.div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </div>
  );
};

export default AppWrap(MotionWrap(Skills), "skills");
